export const questions = [
    {
        id: 1,
        question: "How long does implementation take?",
        answer: "Most organizations complete implementation within 4 to 6 weeks. The timeline depends on the size of your team and the level of structure already in place. We move at a pace that gets you results quickly while ensuring everything is set up the right way.",
    },
    {
        id: 2,
        question: "What Support Do I Get After Launch?",
        answer: "You will receive one week of adoption support and dashboard tuning after your PMO is set up. If you would like continued guidance, our Partnered Advisory package provides three months of dedicated support that includes coaching, process refinement, and ongoing systems/workflow adjustments.",
    },
    {
        id: 3,
        question: "How much customization is possible?",
        answer: "Every implementation is tailored to your organization. We use industry best practices as the foundation, but the workflows, templates, and reporting are customized to match how your teams operate and what your business needs.",
    },
    {
        id: 4,
        question: "Who is ReadyPMO best suited for?",
        answer: "ReadyPMO is designed for organizations that are growing quickly and need more structure around how work gets managed. It is a strong fit for mid-sized businesses, teams without a formal PMO, and organizations that are adopting project management software but struggling to use it effectively. It also works well for departments that lead cross-functional projects and need clearer workflows, better visibility, and more consistent delivery.",
    }
]